<template>
<div>
	<div v-for="(parent, value) in Buckets" v-bind:key="value">
		<div v-if="ShowParent(parent)">
			<FilterSingleSection :Section="parent" @changeBucket="changeBucket" :SelectedFilterOptions="SelectedFilterOptions" />
		</div>
	</div>

	<ListingPrinting :Items="Items" />
</div>
</template>



<script>
import FilterSingleSection from './FilterSingleSection.vue';
import ListingPrinting from '../ProductListing/ListingPrinting.vue';

export default {
	name: 'FilterContainer',
	components: { FilterSingleSection, ListingPrinting },
	methods: {
		ShowParent(parent) {
			if (parent.Title == 'Text Search' || parent.Title == 'Color Family')
				return false;
			return true;
		},
		changeBucket(r) {
          this.$emit('changeBucket', r);
		}
	},
	props: {
		Buckets: Object,
		Items: Array,
		SelectedFilterOptions: String
	}	
}
</script>
